import React from 'react';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import NoteLogo from '../../../../images/front/footer/note_logo.svg';
import XLogo from '../../../../images/front/footer/x_logo.png';
import Typography from '@material-ui/core/Typography';
import T from 'i18n-react';
import { NOTE } from '../../routing';
import FabIconLink from '../components/FabIconLink';
import withStyles from '@material-ui/core/styles/withStyles';
import Link from '@mui/material/Link';
import SvgIconLink from '../components/SvgIconLink';
import FooterLink from '../components/FooterLink';
import styled from 'styled-components';

const CURRENT_YEAR: number = new Date().getFullYear();

const RootGrid = withStyles((theme) => ({
  root: {
    flexDirection: 'column-reverse',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
}))(Grid);

const SnsGrid = withStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      marginLeft: 'auto',
    },
  },
}))(Grid);

const InnerGrid = withStyles((theme) => ({
  root: {
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end',
    },
  },
}))(Grid);

const StyledFabIconLink = withStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
  },
}))(FabIconLink);

const NoteIcon = withStyles({
  root: {
    fontSize: '2.5rem',
    margin: -8,
    verticalAlign: 'middle',
    borderStyle: 'none',
  },
})(Icon) as typeof Icon;

const Copyright = withStyles((theme) => ({
  root: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.common.white,
  },
}))(Typography);

const OfficialLine = withStyles((theme) => ({
  root: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.common.white,
    fontWeight: 'bold',
    margin: 'auto',
    whiteSpace: 'nowrap',
  },
}))(Typography);

const LineImg = styled.img`
  width: auto;
  height: 36px;
  vertical-align: middle;
`;

const XImg = styled.img`
  width: auto;
  height: 20px;
  vertical-align: middle;
`;

const BottomContainer = () => {
  return (
    <RootGrid container spacing={2} alignItems="center">
      <Grid item xs={12} sm="auto">
        <Copyright>©{CURRENT_YEAR} OTETSUTABI.</Copyright>
      </Grid>
      <SnsGrid item xs={12} sm="auto">
        <InnerGrid container spacing={2} alignItems="center">
          <Grid item>
            <StyledFabIconLink
              className="fab fa-facebook"
              href={process.env.OFFICIAL_FACEBOOK_URL as string}
            />
          </Grid>
          <Grid item>
            <Link
              href={process.env.OFFICIAL_TWITTER_URL as string}
              target="_blank"
              rel="noopener noreferrer"
              underline="none"
            >
              <XImg src={XLogo} alt="X" />
            </Link>
          </Grid>
          <Grid item>
            <StyledFabIconLink
              className="fab fa-instagram"
              href={process.env.OFFICIAL_INSTAGRAM_URL as string}
            />
          </Grid>
          <Grid item>
            <SvgIconLink
              href={NOTE}
              icon={<NoteIcon component="img" src={NoteLogo} />}
            />
          </Grid>
          <Grid item>
            <FooterLink href={process.env.LINE_FOOTER_OFFICIAL_DIRECT_URL}>
              <Grid container spacing={1} wrap="nowrap">
                <Grid item>
                  <OfficialLine>
                    {T.translate('footer.officialLine')}
                  </OfficialLine>
                </Grid>
                <Grid item>
                  <LineImg
                    src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png"
                    alt="友だち追加"
                  />
                </Grid>
              </Grid>
            </FooterLink>
          </Grid>
        </InnerGrid>
      </SnsGrid>
    </RootGrid>
  );
};

export default BottomContainer;
